<template>
	<div>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-title class="ptxxx-0">
			<v-form @submit.prevent="search" class="form-inline">
				<v-row>
					<v-col cols="12" class="d-flex flex-wrap align-center">
						<v-select
							outlined
							class="mr-2"
							dense
							label="分组"
							v-model="query.group"
							:items="refs['MetadataGroup']"
							item-title="title"
							item-value="value"
							hide-details
							clearable
							style="max-width: 10rem"
						></v-select>
						<v-text-field
							outlined
							class="search-field-name mr-2"
							dense
							v-model="query.name"
							label="名称"
							hide-details
						/>
						<v-select
							outlined
							class="mr-2"
							dense
							label="状态"
							v-model="query.status"
							:items="refs['MetadataStatus']"
							item-title="title"
							item-value="value"
							hide-details
							clearable
						></v-select>
						<v-btn color="primary" size="large" class="mr-2" @click="search">查询</v-btn>
						<v-icon class="mr-2" v-if="queryPairs.length" @click="reset">$close</v-icon>
					</v-col>
				</v-row>
			</v-form>
		</v-card-title>

		<v-data-table-server
			:headers="headers"
			:items="objects"
			@update:options="load"
			:items-length="parseInt(total)"
			:loading="loading"
			:show-select="showSelect"
			:single-select="singleSelect"
			v-model="selected"
			multi-sort
		>
			<template v-slot:top>
				<slot name="batchActions" v-bind:selected="selected"></slot>
			</template>
			<template #item.group="{ item }">
				{{ groupLabel(item.group) }}
			</template>
			<template #item.range="{ item }">
				{{ item.min_value }}～{{ item.max_value }}
				<span class="text-medium-emphasis"> / {{ item.step || 1 }}</span>
				<span v-if="item.unit" class="text-medium-emphasis"> {{ item.unit }}</span>
			</template>
			<template #item.status="{ item }">
				<enum-chip kind="status" :value="item.status" />
			</template>
			<template v-slot:item.action="{ item }">
				<slot name="actions" v-bind="{ item }"></slot>
			</template>
			<template v-slot:footer>
				<slot name="batchActions" v-bind="{ selected }"></slot>
			</template>
		</v-data-table-server>
	</div>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'
import qs from 'qs'
import EnumChip from '../common/EnumChip.vue'

export default {
	name: 'MetadataList',
	components: { EnumChip },
	props: {
		initQuery: { type: Object, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '分组', value: 'group' },
				{ title: '名称', align: 'left', sortable: true, value: 'name' },
				{ title: '取值范围', sortable: false, value: 'range' },
				{ title: '排序', sortable: true, value: 'sort_order' },
				{ title: '状态', value: 'status' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		const qps = qs.parse(location.search, { ignoreQueryPrefix: true })
		return {
			query: qps,
			currentQuery: {},
			objects: [],
			total: 0,
			loading: false,
			options: null,
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		if (this.initQuery) this.query = clone(this.initQuery)
		this.$api.common.meta('metadata', 'MetadataGroup,MetadataStatus', (res) => {
			this.refs = res
		})
		this.load()
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	methods: {
		groupLabel(group) {
			const found = (this.refs['MetadataGroup'] || []).find((t) => t.value === group)
			return found ? found.title : group
		},
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				if (this.options?.page === 1) this.load()
				else if (this.options) this.options.page = 1
				else this.load()
			} else {
				this.load()
			}
		},
		reset() {
			this.query = {}
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) this.options = options
			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page
			qwp.pagesize = itemsPerPage
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}
			this.currentQuery = clone(this.query)
			this.$api.metadata.search(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>
